export function settingEmailReducer(state = { loading: false, error: null, ok: true }, action) {
    switch (action.type) {
        case 'SET_EMAIL__REQUEST':
            return { loading: true, error: null, ok: false };
        case 'SET_EMAIL__OK':
            return { loading: false, error: null, ok: true };
        case 'SET_EMAIL__FAIL':
            return { loading: false, error: action.error, ok: false };
        default:
            return state;
    }
}
